// extracted by mini-css-extract-plugin
export default {"buttonContainer":"WorkButton_buttonContainer__FQ4E0","button":"WorkButton_button__w3ITY","workbutton":"WorkButton_workbutton__Td+1e"};